/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdatePersonAttachmentStatusViewModel } from "../types/UpdatePersonAttachmentStatusViewModel.ts";
import { eDocumentationStatusSchema } from "./eDocumentationStatusSchema.ts";

export const updatePersonAttachmentStatusViewModelSchema = z.object({
  documentationStatus: z.optional(
    z
      .lazy(() => eDocumentationStatusSchema)
      .describe(
        "0 = Pending | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
      ),
  ),
  documentRejectionId: z
    .number()
    .int()
    .describe(
      "ID do motivo de rejeição do documento. Obrigatório quando o status for Rejected. Opcional nos demais casos.",
    )
    .nullish(),
  reasonName: z
    .string()
    .describe("Nome do motivo de rejeição informado manualmente. Opcional.")
    .nullish(),
}) as unknown as ToZod<UpdatePersonAttachmentStatusViewModel>;
